import type { Messages } from "../types";

export const ru = {
  "common": {
    "brand": "UN8",
    "brandTag": "Эксклюзивные христианские знакомства",
    "continue": "Продолжать",
    "leave": "Оставлять",
    "leaveForNow": "Оставь пока",
    "yes": "Да",
    "no": "Нет",
    "goBack": "Возвращаться",
    "saving": "Сохранение…",
    "submitting": "Отправка…",
    "pleaseWait": "Пожалуйста, подождите…",
    "ellipsis": "…",
    "male": "Мужской",
    "female": "Женский",
    "phases": {
      "gate": "Ворота",
      "verify": "Проверять",
      "setup": "Настраивать",
      "profile": "Профиль"
    },
    "storageQuota": "На этом телефоне недостаточно места для сохраненных ответов. Освободите место и повторите попытку.",
    "storageDisabled": "Этот браузер не сохранит ваши ответы. Выключите приватный режим или разрешите данные сайта, а затем перезагрузите компьютер.",
    "charMeta": "{len}/{min} мин · {current}/{max}",
    "charMetaMin": "мин. {min} символов"
  },
  "welcome": {
    "promise": "Наша цель состоит в том, чтобы вы удалили это приложение как можно быстрее.",
    "sub": "UN8 помогает одиноким христианам найти спутника жизни, а затем уйти. Проверено. Ценности – прежде всего. Никаких бесконечных перелистываний.",
    "signedInAs": "Выполнен вход как {email}",
    "liveServer": "· живой сервер",
    "deviceOnly": "· только это устройство",
    "migrateOffer": "У этого устройства все еще есть локальный профиль. Загрузить его на общий сервер, чтобы другие телефоны могли вас видеть после модерации? Ничего не загружается, пока вы не выберете.",
    "uploadLocalProfile": "Загрузите мой локальный профиль",
    "keepOnDevice": "Хранить только на этом устройстве",
    "migrateNeedGender": "Сначала выберите «Мужской» или «Женский» в своем профиле.",
    "migrateDone": "Текст профиля загружен. Повторно загрузите удостоверение личности, видео и фотографии, чтобы модераторы могли их просмотреть.",
    "deleteConfirm": "Удалить навсегда свою учетную запись, все сообщения и все медиафайлы (включая идентификаторы и видео) с сервера?",
    "accountDeleted": "Аккаунт удален.",
    "begin": "Начинать",
    "continueOnboarding": "Продолжить регистрацию",
    "logIn": "Авторизоваться",
    "logOut": "Выйти",
    "reviewConsole": "Обзор консоли",
    "matching": "Соответствие",
    "deleteMyAccount": "Удалить мою учетную запись"
  },
  "faith": {
    "eyebrow": "Ворота веры",
    "title": "Только христиане",
    "text": "UN8 — это сообщество последователей Иисуса Христа, предназначенное для членов, ищущих партнера, ориентированного на брак и разделяющего эту веру. Эти ворота невозможно пропустить.",
    "yesTitle": "Я христианин",
    "yesBody": "Я следую за Иисусом Христом и ищу партнера для брака, который разделяет эту веру.",
    "noTitle": "Я не христианин",
    "noBody": "UN8 мне не подходит — и это нормально.",
    "respectTitle": "С уважением",
    "respectBody": "UN8 создан для одного сообщества, и мы предпочитаем быть честными, а не тратить ваше время. Используйте «Выйти» ниже или «Назад», если это не ваш дом.",
    "sharedTitle": "Общий фонд",
    "sharedBody": "Вера здесь не ярлык. Это почва, на которой вы встречаетесь.",
    "hintNotChristian": "UN8 предназначен для последователей Иисуса Христа. Нажмите «Оставить» ниже или выберите вариант «Христианин», если это вы.",
    "hintUnset": "Нажмите «Я христианин», чтобы продолжить, или «Выйти/Назад», если это не ваш дом."
  },
  "rules": {
    "eyebrow": "Соглашение сообщества",
    "title": "Как мы относимся друг к другу",
    "text": "Подтверждайте каждое правило. Все три необходимы. Нарушения приводят к окончательному удалению. Фейковые профили блокируются навсегда.",
    "agreeContinue": "Согласен — продолжай",
    "respectful": {
      "title": "Будьте уважительны",
      "description": "Говорите и поступайте достойно. Каждый человек здесь создан по образу Божьему."
    },
    "noSexualContent": {
      "title": "Никакого сексуального контента",
      "description": "Никаких откровенных фотографий, сообщений или запросов. Чистота здесь не обязательна."
    },
    "noDominance": {
      "title": "Не доминируйте и не контролируйте",
      "description": "Никакого принуждения, манипуляций и давления. Любовь не контролирует."
    },
    "hint": "Прежде чем продолжить, отметьте все три обещания."
  },
  "intent": {
    "eyebrow": "",
    "title": "Что ты ищешь?",
    "text": "",
    "marriage": {
      "label": "Спутника жизни",
      "description": ""
    },
    "discernment": {
      "label": "Серьёзное рассуждение",
      "description": ""
    },
    "notCasual": {
      "label": "Ничего лёгкого",
      "description": ""
    },
    "hint": "Выбери одно."
  },
  "account": {
    "eyebrow": "Счет",
    "title": "Создайте свой доступ",
    "text": "Ваш дескриптор создает стабильный идентификатор пользователя. Приложение, проверка, отметки «Нравится» и совпадения — все это привязано к этому идентификатору. Электронная почта не отправляется.",
    "recoveryTitle": "Сохраните код восстановления",
    "recoveryText": "Показан один раз. Без него невозможно сбросить утерянную парольную фразу в этом закрытом тесте.",
    "savedContinue": "Я сохранил — продолжай",
    "handle": "Ручка",
    "handlePlaceholder": "you@example.com или короткий адрес",
    "passphrase": "Парольная фраза",
    "passphrasePlaceholder": "Минимум 8 символов",
    "signedInTitle": "Вошёл в систему",
    "signedInBody": "{email} · {userId}",
    "trustTitle": "Стандарт доверия",
    "trustBody": "Ни один профиль не будет виден до тех пор, пока проверка личности не будет завершена и модерация не одобрит вас.",
    "continueToVerification": "Продолжить проверку",
    "hintEmail": "Введите адрес электронной почты, который включает @.",
    "hintPassword": "Выберите пароль длиной не менее 8 символов."
  },
  "verify": {
    "intro": {
      "eyebrow": "Проверка",
      "title": "Доверие - это ворота",
      "text": "Загрузите правительственное удостоверение, видео-подтверждение и {min}–{max} реальные фотографии. Прежде чем появится ваш профиль, все попадает в очередь проверки.",
      "whyTitle": "Почему мы проверяем",
      "whyBody": "Ловкости и полуправде здесь не место. Фейковые профили блокируются навсегда. Носитель хранится со статусом pending_review до тех пор, пока не будет одобрен.",
      "start": "Начать проверку"
    },
    "steps": {
      "id": {
        "title": "Правительственный идентификатор",
        "description": "Паспорт или национальное удостоверение личности — загрузка камеры или файла."
      },
      "video": {
        "title": "Видео подтверждения",
        "description": "Короткая запись, доказывающая ваше присутствие."
      },
      "photos": {
        "title": "Реальные фотографии",
        "description": "Семь-десять четких фотографий себя."
      },
      "review": {
        "title": "Проверка целостности",
        "description": "Загрузки остаются pending_review до тех пор, пока сотрудники не подтвердят."
      }
    },
    "id": {
      "eyebrow": "Шаг 1 из 4",
      "title": "Правительственный идентификатор",
      "text": "Сфотографируйте или загрузите свой паспорт или национальное удостоверение личности. Ничего не публикуется публично — статус остается pending_review до тех пор, пока сотрудники не подтвердят.",
      "savedTitle": "Идентификатор сохранен",
      "savedBody": "Далее следует короткое подтверждающее видео вашего лица, а затем от 7 до 10 ваших реальных фотографий. Продолжение разблокируется, когда этот идентификатор отображается как сохраненный.",
      "hint": "Сделайте или загрузите фотографию своего государственного удостоверения личности, а затем подождите, пока на нем не появится надпись «Сохранено»."
    },
    "video": {
      "eyebrow": "Шаг 2 из 4",
      "title": "Видео подтверждения",
      "text": "Запишите короткий клип или загрузите его. Лицом к камере. Говорите ясно. Это доказывает, что вы присутствуете, а не очищенная галерея.",
      "hint": "Запишите короткое видео с подтверждением и подождите, пока не появится надпись «Сохранено»."
    },
    "photos": {
      "eyebrow": "Шаг 3 из 4",
      "title": "Реальные фотографии",
      "text": "Добавьте {min}–10 своих недавних фотографий. Используйте камеру или свою библиотеку. Нажмите ×, чтобы удалить любой снимок.",
      "continueToReview": "Продолжить обзор",
      "hint": "Добавьте {min} к 10 своим четким фотографиям. Продолжение разблокируется после сохранения."
    },
    "review": {
      "eyebrow": "Шаг 4 из 4",
      "title": "Проверка целостности",
      "text": "Мультимедиа поставлено в очередь как pending_review{underUser}. Совпадения и лайки будут использовать один и тот же идентификатор.",
      "underUser": "под пользователем {userId}",
      "governmentId": "Правительственный идентификатор",
      "confirmationVideo": "Видео подтверждения",
      "photos": "Фотографии",
      "missing": "Отсутствующий",
      "filesReady": "{count} файлов готово",
      "submittedTitle": "Отправлено на рассмотрение",
      "submittedText": "Идентификатор приложения равен идентификатору пользователя, выполняющего проверку подлинности, поэтому одобрите → пул и взаимные лайки остаются согласованными.",
      "submitContinue": "Отправить и продолжить"
    }
  },
  "setup": {
    "eyebrow": "Настройка учетной записи",
    "title": "Расскажи правду о себе",
    "text": "Эти ответы формируют сопоставление и появляются в обзоре. Мягкая ложь тратит время всех, в том числе и ваше.",
    "beginSetup": "Начать настройку",
    "pillars": {
      "faith": {
        "name": "Вера",
        "text": "Почему вы следуете за Христом."
      },
      "character": {
        "name": "Характер",
        "text": "Лояльность, честность, энтузиазм, преданность делу — оценка от 1 до 10."
      },
      "story": {
        "name": "История",
        "text": "Кто вы и что ищете."
      },
      "life": {
        "name": "Жизнь",
        "text": "Хобби, чтение и призвание."
      }
    },
    "whyChristian": {
      "eyebrow": "Вера",
      "title": "Почему ты христианин?",
      "text": "Короткий и честный ответ. Не проповедь — причина, которая ваша.",
      "label": "Ваш ответ",
      "placeholder": "например Я встретил Христа в период потерь и следую за Ним с тех пор…",
      "hint": "Напишите не менее {min} символов о том, почему вы следуете за Иисусом."
    }
  },
  "scales": {
    "eyebrow": "Масштабы символов",
    "title": "Оцените себя честно",
    "text": "Лояльность, честность, страсть, преданность делу — каждая от 1 до 10. Завышение цифр только позже приведет к несоответствию. Вы должны установить все масштабы, чтобы продолжить.",
    "loyalty": {
      "label": "Уровень лояльности",
      "hint": "Будьте честны: насколько преданно вы поддерживаете тех, кого любите?"
    },
    "honesty": {
      "label": "Уровень честности",
      "hint": "Насколько последовательно вы говорите всю правду?"
    },
    "passion": {
      "label": "Насколько вы страстны?",
      "hint": "Убежденность и глубина — не производительность."
    },
    "commitment": {
      "label": "Уровень приверженности",
      "hint": "Насколько вы готовы построить что-то долговечное?"
    },
    "hint": "Переместите каждый ползунок так, чтобы отображалось число — ни один из них не может оставаться в виде тире."
  },
  "about": {
    "eyebrow": "О вас",
    "title": "Опишите себя в нескольких предложениях",
    "text": "Кто ты, когда никто не выступает. Темперамент, ритм, то, что важно в повседневной жизни.",
    "label": "О вас",
    "placeholder": "Тихое утро, серьёзное отношение к семье, легко смеётся, предпочитает глубину шуму…",
    "hint": "Напишите о себе не менее {min} символов."
  },
  "looking": {
    "eyebrow": "Партнер",
    "title": "Что Вы ищете?",
    "text": "Основные черты характера, которые вы желаете видеть в потенциальном партнере, а не список желаемых образов.",
    "label": "Желаемые черты характера",
    "placeholder": "например Твердая вера, эмоциональная зрелость, доброта в стрессовых ситуациях…",
    "hint": "Напишите не менее {min} символов о партнере, на которого вы надеетесь."
  },
  "loveReady": {
    "eyebrow": "Порог",
    "title": "Готовы ли вы встретить любовь всей своей жизни?",
    "text": "UN8 существует для того, чтобы серьезные одинокие люди нашли партнера, а затем удалили приложение. Продолжаются только разблокировки «Да».",
    "yesTitle": "Да — я готов",
    "yesBody": "Я здесь, чтобы встретить своего человека ясно и смело.",
    "noTitle": "Еще нет",
    "noBody": "Если вы только просматриваете страницы, это сообщество вам не подходит.",
    "comeBackTitle": "Возвращайся, когда будешь готов",
    "comeBackBody": "UN8 предназначен для людей, готовых встречаться, а не собирать варианты. Используйте «Оставить» ниже, если хотите остановиться на данный момент. Ваши ответы сохраняются на этом телефоне.",
    "hintNo": "Только «Да» продолжается. Если вы не готовы, нажмите «Покинуть сейчас» — ваши ответы останутся на этом телефоне.",
    "hintUnset": "Нажмите «Да», если вы готовы встретиться с кем-то для брака."
  },
  "lifestyle": {
    "eyebrow": "Образ жизни",
    "title": "Как вы живете изо дня в день",
    "text": "Спорт, хобби, чтение и профессия — практические сигналы настоящей совместимости.",
    "hobbies": "Текущие виды спорта или хобби",
    "hobbiesPlaceholder": "То, что вы активно делаете, а не то, что вы делали когда-то.",
    "reading": "Вы читаете?",
    "readingHint": "1 = почти никогда · 10 = ежедневно, глубокое чтение",
    "profession": "Профессия/сектор",
    "professionPlaceholder": "например Сестринское дело · Программное обеспечение · Образование · Профессии",
    "hintHobbies": "Назовите хотя бы один вид спорта или хобби, которым вы действительно занимаетесь.",
    "hintReading": "Слайд «Читаешь ли ты?» поэтому отображается число от 1 до 10.",
    "hintProfession": "Напечатайте работу, которую вы делаете, хотя бы короткое слово."
  },
  "faithDepth": {
    "eyebrow": "Соответствие · Вера",
    "title": "Насколько важна ваша вера?",
    "text": "Служение Богу — насколько важно в вашей жизни? Ответьте честно. При сопоставлении это используется для глубины, а не для производительности.",
    "serving": "Служение Богу – важность",
    "servingHint": "10%… 100%. Слайд с шагом 10.",
    "keepsCommandments": "Соблюдаете ли вы заповеди?",
    "grewUpInChurch": "Вы выросли в церкви?",
    "churchAttendance": "Посещение церкви",
    "frequent": {
      "label": "Частый",
      "hint": "Регулярное собрание с телом Христовым."
    },
    "seldom": {
      "label": "Редко",
      "hint": "Иногда не недельный ритм."
    },
    "never": {
      "label": "Никогда",
      "hint": "Сейчас не посещаю."
    },
    "spreadsGospel": "Вы распространяете Евангелие?",
    "hasIdols": "У вас есть кумиры?",
    "hintServing": "Слайд: насколько важно служение Богу в вашей жизни.",
    "hintCommandments": "Ответьте, соблюдаете ли вы заповеди — Да или Нет.",
    "hintGrewUp": "Ответьте, выросли ли вы в церкви — Да или Нет.",
    "hintAttendance": "Выберите, как часто вы посещаете церковь.",
    "hintGospel": "Ответьте, разделяете ли вы Евангелие — да или нет.",
    "hintIdols": "Ответьте, есть ли у вас кумиры — Да или Нет."
  },
  "character": {
    "eyebrow": "Соответствие · Персонаж",
    "title": "Кто ты дома",
    "text": "Характер для ухаживаний — миротворчество, манеры, честность. Раздувание ответов только приведет к несоответствию вас позже.",
    "peacemaker": "Вы миротворец?",
    "homebuilder": "Вы домостроитель?",
    "humorous": "Вы юмористический?",
    "caring": "Заботливый и ласковый?",
    "peacefulHome": "Вы хотите мирный дом без боевых действий?",
    "manners": "Хорошие манеры?",
    "honestyRating": "Рейтинг честности по этой анкете",
    "honestyHint": "1–10 — насколько честно вы отвечаете?",
    "hintPeacemaker": "Ответьте на каждый вопрос «да» или «нет», начиная с «миротворца».",
    "hintHomebuilder": "Ответьте, являетесь ли вы домостроителем.",
    "hintHumorous": "Ответьте, юморист ли вы.",
    "hintCaring": "Ответьте, заботливы ли вы и ласковы.",
    "hintPeaceful": "Ответьте, хотите ли вы мирного дома.",
    "hintManners": "Ответьте, есть ли у вас хорошие манеры.",
    "hintHonesty": "Измените свой рейтинг честности от 1 до 10."
  },
  "history": {
    "eyebrow": "Соответствие · История",
    "title": "Прошлое и готовность",
    "text": "Вещества, детство, шрамы и готовы ли вы к длительным отношениям. Правда здесь защищает вас обоих.",
    "marijuana": "Вы употребляли марихуану?",
    "lsd": "Вы употребляли ЛСД?",
    "otherDrugs": "Вы употребляли другие наркотики?",
    "addicted": "Вы были зависимы?",
    "childhood": "Стабильное, любящее детство?",
    "scars": "Есть шрамы/повреждения?",
    "lasting": "Готовы к длительным отношениям?",
    "hintStart": "Ответьте на каждое «да» или «нет» на этой странице, начиная сверху.",
    "hintLsd": "Ответьте на вопрос о ЛСД — да или нет.",
    "hintOtherDrugs": "Ответьте, употребляли ли вы другие наркотики.",
    "hintAddicted": "Ответьте, были ли вы зависимы.",
    "hintChildhood": "Ответьте, было ли ваше детство стабильным и любящим.",
    "hintScars": "Ответьте, есть ли у вас шрамы.",
    "hintLasting": "Ответьте, готовы ли вы к длительным отношениям."
  },
  "appearance": {
    "eyebrow": "Соответствие · Внешний вид",
    "title": "Татуировки",
    "text": "Ваши татуировки и приемлемы ли для вас татуировки на партнере.",
    "hasTattoos": "У тебя есть татуировки?",
    "acceptsPartner": "Принимать татуировки на партнере?",
    "hintHas": "Скажите, есть ли у вас татуировки — да или нет.",
    "hintAccepts": "Скажите, приемлемы ли для вас татуировки на партнере."
  },
  "home": {
    "eyebrow": "Соответствие · Дом и земля",
    "title": "Земля, навыки, самодостаточность",
    "text": "Травы, выращивание продуктов питания, фруктовый лес, подготовка почвы, общественное сельское хозяйство, консервирование, выживание — и любые специальные навыки.",
    "herbKnowledge": "Знание трав?",
    "plantOwn": "Вы сажаете свои собственные фрукты и овощи?",
    "fruitForest": "Вас интересует фруктовый лес?",
    "prepping": "Готовитесь к катастрофам?",
    "communityFarming": "Общественное сельское хозяйство/независимая жизнь?",
    "canning": "Консервирование и консервирование?",
    "survival": "Навыки выживания?",
    "specialSkills": "Специальные навыки (по желанию)",
    "specialPlaceholder": "Что-нибудь еще, что вы приносите в дом или на землю…",
    "hintStart": "Ответьте на все вопросы «да» или «нет» о земле и навыках, начиная сверху.",
    "hintPlant": "Ответьте, сажаете ли вы свои собственные фрукты и овощи.",
    "hintFruitForest": "Ответьте, интересует ли вас фруктовый лес.",
    "hintPrepping": "Ответьте, готовитесь ли вы к бедствиям.",
    "hintCommunity": "Ответьте, интересует ли вас общественное фермерство.",
    "hintCanning": "Ответьте, можете ли вы и сохранить продукты.",
    "hintSurvival": "Ответьте, есть ли у вас навыки выживания."
  },
  "family": {
    "eyebrow": "Соответствие · Семья",
    "title": "Дети, глубина веры, вещества",
    "text": "Что вам нужно от партнера по силе веры, детям и прошлому употреблению психоактивных веществ.",
    "children": "Дети",
    "wants": {
      "label": "Хочет детей",
      "hint": "Создание семьи является частью видения."
    },
    "doesNotWant": {
      "label": "Не хочет детей",
      "hint": "Ясное «нет» детям."
    },
    "open": {
      "label": "Открыть",
      "hint": "Проницательный — не заперт в любом случае."
    },
    "hasLivingWith": {
      "label": "Есть дети — живу с ними",
      "hint": "Дети уже являются частью повседневной жизни."
    },
    "requiredFaith": "Минимальный уровень веры, который вам нужен в партнере",
    "requiredFaithHint": "10%… 100%. Жесткие ворота, когда обе стороны ответили.",
    "acceptsSubstances": "Признать употребление психоактивных веществ партнером в прошлом?",
    "hintChildren": "Выберите одну карточку о детях.",
    "hintFaith": "Укажите минимальный уровень веры, на который вы надеетесь в партнере.",
    "hintSubstances": "Скажите, приемлемо ли употребление психоактивных веществ партнером в прошлом."
  },
  "ancestry": {
    "eyebrow": "Соответствие · Фон",
    "title": "Фоновые настройки",
    "text": "Поделитесь своим опытом и тем, чему вы открыты в партнере. Это только формирует рейтинг — оно никогда не скрывает кого-то из колоды.",
    "yourBackground": "Ваш опыт (выберите все, что подходит)",
    "openToPartner": "Открыт для партнёра",
    "codeDesc": "Код: {code}",
    "anyDesc": "Наибольшее предпочтение широте — рекомендуется, если вы не уверены.",
    "preferenceOnly": "Только предпочтение — не ворота.",
    "hintOwn": "Отметьте хотя бы один фон, который описывает вас. Это только помогает ранжированию — оно никогда никого не скрывает.",
    "hintAccepted": "Отметьте в партнере то, чему вы открыты, или «Открыт — нет предпочтений»."
  },
  "interests": {
    "eyebrow": "Соответствие · Интересы",
    "title": "Что вам нравится",
    "text": "Выберите хотя бы один. Перекрытие помогает ранжированию; молчание никогда не наказывается.",
    "hint": "Отметьте хотя бы один интерес."
  },
  "reflection": {
    "eyebrow": "Сопоставление · Отражение",
    "title": "Своими словами",
    "text": "Эти четыре ответа показаны полностью и не оцениваются. Напишите, что верно.",
    "describeYourself": "Опиши себя",
    "lifePurpose": "Цель жизни",
    "fifteenYear": "Ты и любовь всей твоей жизни через 15 лет",
    "weaknesses": "Слабые стороны",
    "hintDescribe": "Опишите себя минимум в {min} символах.",
    "hintPurpose": "Напишите цель своей жизни не менее чем в {min} символов.",
    "hintVision": "Напишите видение на 15 лет, используя не менее {min} символов.",
    "hintWeaknesses": "Назовите слабость, используя не менее {min} символов."
  },
  "profile": {
    "eyebrow": "Профиль",
    "title": "Несколько предметов первой необходимости",
    "text": "Будьте проще. Пол здесь бинарный — мужской или женский — для четкого соответствия.",
    "firstName": "Имя",
    "firstNamePlaceholder": "Как вы хотите, чтобы вас знали",
    "age": "Возраст",
    "agePlaceholder": "18+",
    "city": "Город",
    "cityPlaceholder": "Где вы находитесь",
    "sex": "Секс",
    "maleBody": "Я мужчина.",
    "femaleBody": "Я женщина.",
    "hintName": "Введите свое имя (минимум две буквы).",
    "hintAge": "Возраст должен быть 18 лет или старше.",
    "hintCity": "Введите город, в котором вы живете.",
    "hintGender": "Выберите «Мужской» или «Женский», чтобы сопоставление сработало."
  },
  "ready": {
    "title": "Вы можете войти.",
    "textNamed": "{name}, ваша проверка и настройка записываются. Медиафайл — pending_review. Добро пожаловать в UN8 — найдите своего человека и удалите приложение.",
    "text": "Ваша проверка и настройка записываются. Медиафайл — pending_review. Добро пожаловать в UN8 — найдите своего человека и удалите приложение.",
    "summaryAria": "Сводка настройки",
    "christianRules": "Христианин · правила подтверждены",
    "mediaLine": "ID · видео · {photoCount} фото · очередь {pending}",
    "scalesLine": "Весы L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "genderProfession": "{gender} · {profession}",
    "sexUnset": "Секс —",
    "professionFallback": "профессия",
    "userLine": "Пользователь {userId}",
    "enterMatching": "Введите соответствие",
    "needGender": "Вернитесь к шагу профиля и выберите «Мужской» или «Женский», затем повторите попытку."
  },
  "match": {
    "brandTag": "Соответствие",
    "navOnboarding": "Регистрация",
    "navReview": "Обзор",
    "navMatching": "Соответствие",
    "logOut": "Выйти",
    "enterTitle": "Введите соответствие",
    "enterText": "Войдите в систему, используя тот же адрес электронной почты, что и при регистрации. Приложение, пул, лайки и совпадения — все используют ваш стабильный идентификатор пользователя.",
    "email": "Электронная почта",
    "emailPlaceholder": "you@example.com",
    "password": "Пароль",
    "passwordPlaceholder": "Ваш пароль",
    "logIn": "Авторизоваться",
    "guestOr": "Или попробуйте гостевой сеанс (стабильный идентификатор для каждого браузера · только демо-версия)",
    "guestMan": "Гость как мужчина",
    "guestWoman": "Гость в образе женщины",
    "goOnboarding": "Перейти к регистрации →",
    "guestSession": "Гостевая сессия · демо-пул",
    "packTitle": "Твои четверо",
    "packSkip": "Нажми, чтобы продолжить",
    "newSelection": "Новый выбор",
    "backToFour": "← Назад к своим четырём",
    "whoLikedTitle": "Who liked you",
    "whoLikedLocked": "Subscribe to see names on the weekly deck — inbound hearts still show on Messages.",
    "whoLikedEmpty": "No one new has liked you yet.",
    "man": "мужчина",
    "woman": "женщина",
    "navSelection": "Выбор",
    "navMessages": "Сообщения",
    "navProfile": "Профиль",
    "tabToday": "Выбор",
    "tabMatches": "Матчи ({count})",
    "yourMatches": "Ваши совпадения",
    "matchesSub": "Постоянный взаимный интерес · {count} исходящий {likesWord}",
    "like": "нравиться",
    "likes": "любит",
    "emptyMatches": "Пока нет взаимного интереса. Продолжай различать выбор этой недели.",
    "valuesScore": "Значения {score}",
    "chatOpen": "· Чат открыт",
    "tapToChat": "· Нажмите, чтобы пообщаться",
    "personLine": "{name}, {age}",
    "cityValues": "{city} · Значения {score}",
    "noProfileYet": "Профиля пока нет",
    "noProfileText": "Завершите регистрацию или нажмите «Онбординг» вверху, а затем «Начать». Сопоставление гостей находится на экране ввода, если вы хотите только посмотреть.",
    "matchingPaused": "Сопоставление приостановлено",
    "moderationDemoNote": "Showing demo people so you can try matching while you wait.",
    "noOneYet": "Пока некому показать",
    "todaysSetDone": "Это выбор этой недели",
    "weeklyTitle": "Твои 4 на эту неделю",
    "weeklyTitleCount": "Твои {count} на эту неделю",
    "weeklyCountdown": "Следующий выбор через {days} дн.",
    "weeklyCountdownOne": "Следующий выбор через 1 день",
    "weeklyCountdownSoon": "Следующий выбор скоро",
    "shortWeekCopy": "This week there are {count}. We never suggest someone who is not a fit.",
    "shortWeekTwo": "This week there are two. We never suggest someone who is not a fit.",
    "weekDone": "Это выбор этой недели",
    "weekDoneText": "You have discerned everyone we could honestly suggest. Come back when the next selection opens.",
    "emptyNeverHad": "В списке этой недели пока никого нет. Пул наполняется — открой Выбор чуть позже или вернись, когда одобрим больше людей.",
    "emptyDone": "Ты просмотрел выбор этой недели. Вернись к следующему открытию или сбрось колоду.",
    "likesMayNotStick": "Лайки могут не прилипнуть.",
    "poolMeta": "Пул: {pool} · Совпадений: {matches} · Понравилось: {liked}",
    "demoPool": "демо",
    "livePool": "{source} ({count})",
    "resetDeck": "Сбросить колоду",
    "backOnboarding": "Вернемся к регистрации",
    "feedEyebrowDemo": "Недельный выбор · Демо",
    "feedEyebrowLive": "Недельный выбор · Пул ({source}, {count})",
    "feedTitle": "Различать с осторожностью",
    "left": "осталось {count}",
    "pass": "Проходить",
    "interested": "Заинтересовано",
    "swipeHint": "Проведите пальцем по экрану или используйте кнопки. Матч открывается только тогда, когда интерес взаимен и сохраняется.",
    "celebrationEyebrow": "Взаимный интерес",
    "celebrationTitle": "Вы совпали",
    "celebrationText": "{self} и {other} проявили интерес. Выравнивание значений: {score}.",
    "celebrationWhyLabel": "Why you matched",
    "celebrationNote": "Для этого матча чат разблокирован. Сохраняйте уважение — договор важнее удобства.",
    "openChat": "Открыть чат",
    "keepDiscerning": "Продолжайте проницательность",
    "cardSeeking": "Ищу",
    "cardHobbies": "Хобби",
    "affinity": "Близость",
    "valuesScoreLabel": "Оценка ценностей",
    "scoreStrong": "Сильное выравнивание",
    "scoreSolid": "Твердое выравнивание",
    "scoreModerate": "Умеренное выравнивание",
    "scoreDifferent": "Разные ритмы",
    "characterAxisFoot": "Ось характера включает в себя четыре столпа.",
    "youThem": "Вы {self} · Они {other}",
    "stampInterest": "Интерес",
    "stampPass": "Проходить",
    "explainLikedYou": "They already liked you — this is mutual interest waiting to happen.",
    "explainLegacyClose": "Ваши оценки ценностей близки друг к другу ({score} из 100).",
    "explainLegacyFuller": "Более полное «почему» появится после того, как вы оба ответите на соответствующие вопросы.",
    "explainFaith": "Интенсивность вашей веры близка — вы так же серьезно относитесь к следованию за Иисусом.",
    "explainCharacter": "То, как вы относитесь к людям дома, выстраивается в очередь — мир, манеры и забота.",
    "explainPurpose": "Вы одинаково оценили свою честность, что является признаком общей серьезности.",
    "explainHome": "У вас есть общий интерес к земле, выращиванию продуктов питания или самодостаточному дому.",
    "explainAncestry": "Вы оба предпочитаете схожие семейные корни. Это предпочтение, а не фильтр — от него никто не скрывается.",
    "explainTemperament": "Ваши интересы и темперамент совпадают.",
    "explainFallback": "Ответы, которые вы оба заполнили, возможно, совпадают.",
    "explainOverall": "Общая близость {score} равна 100.",
    "affinityAxes": {
      "faith": "Интенсивность веры",
      "character": "Характер и поведение",
      "purpose": "Согласование жизненных целей",
      "home": "Дом и самодостаточность",
      "ancestry": "Культурная и фоновая близость",
      "temperament": "Подходит по темпераменту"
    },
    "scaleAxes": {
      "loyalty": "Верность",
      "honesty": "Честность",
      "passion": "Страсть",
      "commitment": "Обязательство"
    },
    "verify": {
      "brandTag": "Verify",
      "title": "Verify to message",
      "sub": "Anyone can browse and heart. A conversation needs your ID and a short confirmation video. Submitted is enough — review can wait.",
      "cta": "Add ID and video",
      "videoCta": "Add a confirmation video",
      "submitted": "ID and video are in. You can message while we review.",
      "done": "You’re verified.",
      "back": "Back",
      "continue": "Continue",
      "idEyebrow": "Identity",
      "videoEyebrow": "Presence",
      "idText": "Passport or national ID. Nothing is posted publicly. Submitted is enough to talk.",
      "videoText": "A short clip (about {seconds} seconds). Face the camera. This proves you are present."
    }
  },
  "chat": {
    "brandTag": "Чат",
    "unavailableTitle": "Чат недоступен",
    "unavailableText": "Это совпадение отсутствует или не принадлежит вашему сеансу.",
    "backToMatches": "Вернуться к матчам",
    "backMatches": "← Спички",
    "valuesSubscriber": "Значения {score} · Подписчик",
    "valuesTrial": "Значения {score} · Пробная версия",
    "valuesKept": "Значения {score} · Совпадение сохранено",
    "empty": "Приветствуйте осторожно. На общем сервере сообщения синхронизируются на оба телефона после взаимного совпадения.",
    "placeholder": "Сообщение {name}…",
    "ariaMessage": "Сообщение",
    "send": "Отправлять"
  },
  "billing": {
    "paywallCopy": "После бесплатной пробной версии сохраните всех, с кем вы уже связались, и продолжайте общаться. Чтобы увидеть новых людей, подпишитесь.",
    "signInToMatch": "Войдите, чтобы использовать сопоставление.",
    "signInFirst": "Сначала войдите в систему.",
    "subscriberUntil": "Подписчик · до {date}",
    "renewal": "обновление",
    "freeTrial": "Бесплатная пробная версия · {days} дней (заканчивается {date})",
    "soon": "скоро",
    "trialEnded": "Пробная версия завершена · матчи и чат остаются открытыми",
    "subscribe": "Подписаться · ${price}/мес.",
    "subscribeEarly": "Подпишитесь заранее · ${price}/мес.",
    "activeNote": "Подписка активна — вы снова можете видеть новых людей.",
    "playOnly": "Subscription is Google Play Billing only (app install). There is no web checkout here.",
    "playOnlyShort": "Billing via Google Play only — no web payment."
  },
  "auth": {
    "recoveryTitle": "Сохраните код восстановления",
    "recoveryText": "Запишите это сейчас. Оно показано один раз. Если вы потеряете парольную фразу, этот код — единственный способ сбросить его в закрытом тесте.",
    "savedContinue": "Я сохранил — продолжай",
    "welcomeBack": "Добро пожаловать",
    "createAccount": "Создайте свою учетную запись",
    "intro": "Дескриптор и парольная фраза. Ни письмо, ни СМС не отправляются. Ваш идентификатор остается стабильным во время регистрации, проверки и сопоставления.",
    "tabLogin": "Авторизоваться",
    "tabRegister": "Зарегистрироваться",
    "handle": "Ручка",
    "handlePlaceholder": "you@example.com или короткий адрес",
    "passphrase": "Парольная фраза",
    "passphrasePlaceholder": "Минимум 8 символов",
    "submitLogin": "Авторизоваться",
    "submitRegister": "Зарегистрироваться",
    "backWelcome": "Вернуться к приветствию"
  },
  "options": {
    "origin": {
      "african": "Африканский",
      "european": "Европейский",
      "asian": "Азиатский",
      "latino": "Латиноамериканец / латиноамериканец",
      "middleEastern": "Ближний Восток",
      "indigenous": "Местный",
      "mixed": "Смешанный",
      "other": "Другой",
      "dutch": "Голландский",
      "german": "немецкий",
      "any": "Открытый — без предпочтений"
    },
    "interest": {
      "prayer": "Молитва",
      "worship": "Поклонение",
      "reading": "Чтение",
      "hiking": "Пеший туризм",
      "music": "Музыка",
      "cooking": "Кулинария",
      "farming": "Сельское хозяйство/садоводство",
      "sports": "Спорт",
      "missions": "Миссии",
      "family": "Семейная жизнь",
      "crafts": "Ремесла",
      "outdoors": "на открытом воздухе"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "Да",
      "no": "Нет"
    },
    "id": {
      "titleEmpty": "Правительственный идентификатор",
      "titleReady": "удостоверение личности готово",
      "hintEmpty": "Паспорт или национальное удостоверение личности. Сделайте живое фото или выберите изображение/PDF. Все четыре угла видны.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "savedSuffix": "· сохранен",
      "previewAlt": "Предварительный просмотр государственного удостоверения личности",
      "pdfAria": "PDF-документ выбран",
      "takePhoto": "Сфотографироваться",
      "retake": "Пересдать",
      "chooseFile": "Выбрать файл",
      "replaceFile": "Заменить файл",
      "remove": "Удалять",
      "uploading": "Загрузка…",
      "cameraTitle": "Сфотографируйте свое удостоверение личности",
      "signIn": "Войдите в систему перед загрузкой идентификатора.",
      "uploadFailed": "Загрузка не удалась. Попробуйте еще раз.",
      "badFile": "Не удалось использовать этот файл."
    },
    "video": {
      "titleEmpty": "Видео подтверждения",
      "titleLive": "Камера в прямом эфире",
      "titleReady": "Видео готово",
      "hintEmpty": "Назовите свое имя и честно присоединитесь к UN8. 5–15 секунд.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "rec": "ЗАПИСЬ {seconds}с",
      "record": "Записывать",
      "cameraUpload": "Загрузка камеры",
      "chooseFile": "Выбрать файл",
      "startRecording": "Начать запись",
      "cancel": "Отмена",
      "stopSave": "Остановить и сохранить",
      "recordAgain": "Записать еще раз",
      "replaceFile": "Заменить файл",
      "remove": "Удалять",
      "unsupported": "Запись прямого эфира здесь недоступна. Используйте загрузку с камеры или выберите файл.",
      "permissionDenied": "Разрешение на использование камеры отклонено. Вы все равно можете загрузить короткий видеофайл.",
      "signIn": "Войдите в систему перед загрузкой видео.",
      "uploadFailed": "Загрузка не удалась. Попробуйте еще раз.",
      "saveFailed": "Не удалось сохранить запись.",
      "badVideo": "Не удалось использовать это видео."
    },
    "photos": {
      "count": "{count} / {max} фотографий",
      "minimumMet": "Минимум соблюден",
      "moreRequired": "Требуется еще {n}",
      "listAria": "Проверочные фотографии",
      "photoAlt": "Фото {n}",
      "removeAria": "Удалить фото {n}",
      "camera": "Камера",
      "takePhoto": "Сфотографироваться",
      "chooseFiles": "Выберите файлы",
      "uploading": "Загрузка…",
      "hint": "Сфотографировать открывает живую камеру. Выбор файлов предназначен только для выбора галереи. Четкие снимки лица — никаких фильтров, скрывающих личность. Макс {max}.",
      "cameraTitle": "Сфотографируй себя",
      "signIn": "Прежде чем загружать фотографии, войдите в систему.",
      "someFailed": "Некоторые фотографии не удалось загрузить. Повторите неудачные попытки.",
      "addFailed": "Не удалось добавить фотографии."
    },
    "liveStill": {
      "titleDefault": "Камера",
      "close": "Закрывать",
      "capture": "Захватывать",
      "cancel": "Отмена",
      "hint": "Держитесь устойчиво. Камера прямой трансляции остается открытой, пока вы не сделаете съемку.",
      "unavailable": "Камера недоступна в этом браузере. Вместо этого используйте «Выбрать файл».",
      "permissionDenied": "Разрешение камеры отклонено или недоступно. Вместо этого используйте «Выбрать файл».",
      "frameFailed": "Не удалось запечатлеть этот кадр.",
      "saveFailed": "Не удалось сохранить фотографию."
    },
    "uploadStatus": {
      "uploading": "загружаю…",
      "failed": "загрузка не удалась",
      "savedLocally": "сохранено локально",
      "uploaded": "загружено",
      "stored": "хранится",
      "awaitingUpload": "Ожидание загрузки",
      "localFallbackNote": "{error} Файл сохранен на этом устройстве; повторите попытку, когда конечная точка знака активна."
    }
  },
  "language": {
    "label": "Язык",
    "choose": "Выберите язык"
  },
  "shell": {
    "back": "Назад",
    "goBackAria": "Возвращаться"
  }
} as Messages;
